import Image, {ImageProps} from 'next/image';
import {useRouter} from 'next/router';
import React, {forwardRef} from 'react';

import {TypoComponentsContentSectionFramedImageImageDataItem} from 'lib/api/strapi';

interface StrapiImageProps extends Omit<ImageProps, 'src' | 'alt'> {
  image: TypoComponentsContentSectionFramedImageImageDataItem;
  fallbackImage?: TypoComponentsContentSectionFramedImageImageDataItem;
  parentComponentName?: string;
}

const StrapiImage = forwardRef<HTMLImageElement, StrapiImageProps>(
  ({image, fallbackImage, ...props}, ref) => {
    const {locale} = useRouter();

    const imageAttrs = image?.attributes || {};
    const fallbackAttrs = fallbackImage?.attributes || {};

    const url = imageAttrs.url || fallbackAttrs.url;
    const height = imageAttrs.height || fallbackAttrs.height;
    const width = imageAttrs.width || fallbackAttrs.width;
    const alternativeText = imageAttrs.alternativeText || fallbackAttrs.alternativeText;
    const alternativeTextEN = imageAttrs.alternativeTextEN || fallbackAttrs.alternativeTextEN;

    // If URL is missing, don't render the image
    if (!url) {
      return null;
    }

    return (
      <>
        <Image
          ref={ref}
          src={url}
          height={height}
          width={width}
          alt={locale === 'de' ? alternativeText : alternativeTextEN || alternativeText}
          {...props}
        />
      </>
    );
  },
);

StrapiImage.displayName = 'StrapiImage';

export default StrapiImage;
